import { styled } from "@puzzle/theme";

export const LogoAndWordmarkContainer = styled("div", {
  display: "flex",
  alignItems: "center",
  transition: "transform 0.15s ease-in-out",

  "& > *:last-child": {
    marginLeft: "$2",
    transition: "opacity 0.15s ease-in-out",
  },

  defaultVariants: {
    showWordmark: true,
  },
  variants: {
    showWordmark: {
      false: {
        transform: "translateX(60px)",
        "& > *:last-child": {
          opacity: "0",
        },
      },
    },
  },
});
